<template>
  <div id="bjzc-service">
    <PageHeading>{{ $t('service.name') }}</PageHeading>
    <div class="bjzc-page-content">
      <ServiceList />
    </div>
  </div>
</template>

<script>
import ServiceList from '../components/ServiceList.vue'
export default {
  components: { ServiceList },
  created() {
    this.$eventBus.$emit('setBreadcrumb', [
      { path: '/', title: '首页', title_en: 'Home' },
      {
        path: '/service',
        title: this.$t('breadcrumb.service', 'zh'),
        title_en: this.$t('breadcrumb.service', 'en')
      }
    ])
  }
}
</script>

<style lang="scss">
#bjzc-service {
}
@media (max-width: ($screen-width-m - 1)) {
  #bjzc-service {
  }
}
</style>
